<div class="header">
  <div>
    <h2>Organization</h2>
    <p>Manage and configure your organization details and settings</p>
  </div>
  <button class="add-btn" (click)="toggleModal('add')">
    <img src="assets/images/PlusIcon.svg" alt="" />Add New Organization
  </button>
</div>

<div class="rp-body">
  <div class="table-wrapper">
    <table>
      <thead>
        <tr>
          <th>Name</th>
          <th>Slogan</th>
          <th>Type</th>
          <th>City</th>
          <th class="text-right pr-4">Action</th>
        </tr>
      </thead>
      <tbody *ngIf="loading || showSkeleton">
        <tr *ngFor="let row of skeletonRows">
          <td *ngFor="let col of skeletonCols">
            <div class="skeleton-cell"></div>
          </td>
        </tr>
      </tbody>

      <!-- REAL DATA BODY -->
      <tbody *ngIf="!loading && !showSkeleton">
        @for (item of organizations; track item.id) {
        <tr>
          <td>{{ item.name }}</td>
          <td>{{ item.slogan }}</td>
          <td>{{ item.type }}</td>
          <td>{{ item.city }}</td>
          <td class="text-right icon-btns">
            <button class="btn-icon" (click)="openEditModal(item)">
              <img src="assets/images/editIcon.svg" alt="Edit" />
            </button>
            <button class="btn-icon" (click)="openDeleteModal(item)">
              <img src="assets/images/trashIcon.svg" alt="Delete" />
            </button>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
</div>

<!-- Add/Edit Modal -->
<app-add-popup *ngIf="showAddEditModal" [title]="isEditMode ? 'Edit Organization' : 'Add New Organization'" [subtitle]="
    isEditMode
      ? 'Update your organization details and information.'
      : 'Create an organization to manage your company structure and settings.'
  " [iconPath]="
    isEditMode ? 'assets/images/editPopup.png' : 'assets/images/addPopup.png'
  " (close)="toggleModal('add')">
  <form [formGroup]="organizationForm" (ngSubmit)="onSave()">
    <div class="form-row">
      <div class="input-group">
        <label>Organization Name*</label>
        <input type="text" formControlName="org_name" placeholder="Write here" />
      </div>

      <div class="input-group">
        <label>Slogan*</label>
        <input type="text" formControlName="org_slogan" placeholder="Write here" />
      </div>
    </div>

    <div class="form-row">
      <div class="input-group">
        <label>Organization Type*</label>
        <input type="text" formControlName="org_type" placeholder="Write here" />
      </div>

      <div class="input-group">
        <label>City*</label>
        <input type="text" formControlName="org_city" placeholder="Write here" />
      </div>
    </div>

    <div class="form-row-3">
      <div class="input-group">
        <label>State*</label>
        <input type="text" formControlName="org_state" placeholder="Write here" />
      </div>

      <div class="input-group">
        <label>Country*</label>
        <input type="text" formControlName="org_country" placeholder="Write here" />
      </div>

    <div class="input-group">
      <label>Postal Code*</label>
      <input type="text" formControlName="org_postal_code" placeholder="Write here" />
    </div>
    </div>

    <div class="input-group">
      <label>Address 1*</label>
      <textarea formControlName="org_address1" placeholder="Write address here"></textarea>
    </div>

    <div class="input-group">
      <label>Address 2*</label>
      <textarea formControlName="org_address2" placeholder="Write address here"></textarea>
    </div>

  

    <div class="modal-footer">
      <button type="button" class="btn-cancel" (click)="toggleModal('add')">
        Cancel
      </button>
      <button type="submit" class="btn-save" [disabled]="organizationForm.invalid">
        <span><img src="assets/images/savePopup.svg" alt="" /></span>
        {{ isEditMode ? "Update" : "Save" }}
      </button>
    </div>
  </form>
</app-add-popup>

<!-- Delete Modal -->
<app-add-popup *ngIf="showDeleteModal" title="Delete Organization"
  subtitle="Are you sure you want to delete this organization? This action cannot be undone."
  iconPath="assets/images/deleteicon.svg" (close)="toggleModal('delete')">
  <div class="modal-footer justify-center">
    <button type="button" class="btn-cancel" (click)="toggleModal('delete')">
      Cancel
    </button>
    <button type="button" class="btn-save" (click)="confirmDelete()">
      <span> <fa-icon [icon]="faTrashCan"></fa-icon></span> Delete
    </button>
  </div>
</app-add-popup>
